import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { ApplicationConfig } from '../config/config';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class TimeoutInterceptor implements HttpInterceptor {
  private APP_TIMEOUT_FAST: number;
  private APP_TIMEOUT_MEDIUM: number;
  private APP_TIMEOUT_SLOW: number;
  private defaultTimeout: number;

  constructor(private config: ApplicationConfig) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.APP_TIMEOUT_SLOW === undefined || isNaN(this.APP_TIMEOUT_SLOW)) {
      this.setTimeoutValues();
    }
    let timeoutreq: number = this.defaultTimeout;
    if (req.headers.has(HTTP_TIMEOUT)) {
      timeoutreq = Number(req.headers.get(HTTP_TIMEOUT));
      if (
        timeoutreq !== this.APP_TIMEOUT_SLOW &&
        timeoutreq !== this.APP_TIMEOUT_MEDIUM &&
        timeoutreq !== this.APP_TIMEOUT_FAST
      ) {
        timeoutreq = this.defaultTimeout;
      }
      const request = req.clone({
        headers: req.headers.delete(HTTP_TIMEOUT)
      });
      return next.handle(request).pipe(timeout(timeoutreq));
    }
    return next.handle(req).pipe(timeout(timeoutreq));
  }

  setTimeoutValues() {
    this.APP_TIMEOUT_FAST = Number.parseInt(
      this.config.get('APP_TIMEOUT_FAST')
    );
    this.APP_TIMEOUT_MEDIUM = Number.parseInt(
      this.config.get('APP_TIMEOUT_MEDIUM')
    );
    this.APP_TIMEOUT_SLOW = Number.parseInt(
      this.config.get('APP_TIMEOUT_SLOW')
    );
    this.defaultTimeout = this.APP_TIMEOUT_SLOW;

    // if the above keys are not stored in configuration,
    // or somehow the application properties are not available at the time of object construction
    // we should still have a default numeric value to prevent timeouts
    if (!this.defaultTimeout || isNaN(this.defaultTimeout)) {
      this.defaultTimeout = 15000; // 15 seconds
    }
  }
}

export const HTTP_TIMEOUT = 'timeout';
